//@import dependencies
import React from 'react'
import { useSelector } from 'react-redux';
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../adminDashboardModule.scss'

// @ADD Component types
interface IAdminDashboardModuleLayoutProps {}

const AdminDashboardModuleLayout: React.FC<IAdminDashboardModuleLayoutProps> = (props) => {

  const user = useSelector((state: any) => state.auth?.user?.data ? state.auth.user.data : null)

  return(
    <div className='admin_dashboard-component mt-3'>
      {user && (
        <>
          <h1>Bienvenido {user.profile.first_name}</h1>
          <p>Aca podrás administrar el campus virtual</p>
        </>
      )}
      {/* <ButtonComponent
        variant='secondary'
        onClick={handleOpenSurvey}
      >
        Abrir encuesta
      </ButtonComponent> */}
    </div>
  )
}

export default AdminDashboardModuleLayout
